import React from 'react'

// styles
import GlobalFormStyles from './styles/StylesForms'

export default function FormInput(props) {
    // props
    const {
        formClassName,
        inputType,
        inputId,
        inputName,
        inputClassName,
        placeholder,
        isDisabled,
        onChange = () => { },
        label,
        labelClassName,
        isRequired,
        icon,
        iconClassName,
        onIconClick = () => { },
        inputRef,
    } = props

    return (
        <GlobalFormStyles className={`${formClassName ?? ""} ${icon ? "has-icon" : ""}`}>
            {/* LABEL */}
            {
                label ? (
                    <label className={`mb-1 ${labelClassName ?? ""}`}>
                        {label}
                        {isRequired && <span className="required ms-1 st-fs-12 text-danger">*</span>}
                    </label>
                ) : null
            }

            {/* INPUT */}
            <div className="input-content">
                <input
                    type={inputType ?? "text"}
                    id={inputId}
                    name={inputName ?? ""}
                    className={`form-control ${inputClassName ?? ""}`}
                    placeholder={placeholder}
                    disabled={isDisabled}
                    onChange={onChange}
                    ref={inputRef ?? null}
                />

                {/* ICON */}
                {
                    icon ? (
                        <div className={`icon ${iconClassName ?? ""}`} onClick={onIconClick}>
                            {icon}
                        </div>
                    ) : null
                }
            </div>
        </GlobalFormStyles>
    )
}
